import { t } from "@lingui/macro";
import { ScrollArea, Separator } from "@reactive-resume/ui";
import { cn } from "@reactive-resume/utils";
import { useRef, useState } from "react";

import ContainerAIChat from "./container-ai-chat";
import { ExportSection } from "./sections/export";
import { LayoutSection } from "./sections/layout";
import { NotesSection } from "./sections/notes";
import { PageSection } from "./sections/page";
import { SecOptimization } from "./sections/sec-optimization";
import { SecTranslation } from "./sections/sec-translation";
import { TemplateSection } from "./sections/template";
import { ThemeSection } from "./sections/theme";
import { TypographySection } from "./sections/typography";
import { SectionIcon } from "./shared/section-icon";

export const RightSidebar = () => {
  const containterRef = useRef<HTMLDivElement | null>(null);

  const [isAIChatOpen, setIsAIChatOpen] = useState(false);

  const scrollIntoView = (selector: string) => {
    setTimeout(
      () => {
        const section = containterRef.current?.querySelector(selector);
        section?.scrollIntoView({ behavior: "smooth" });
      },
      isAIChatOpen ? 100 : 0,
    );
    setIsAIChatOpen(false);
  };

  return (
    <div className="flex h-screen flex-row bg-secondary-accent/30">
      <ScrollArea
        orientation="vertical"
        className={cn("h-screen flex-1 pb-16 lg:pb-0", isAIChatOpen ? "hidden" : "")}
      >
        <div ref={containterRef} className="grid gap-y-6 p-6 @container/right">
          <TemplateSection />
          <Separator />
          <LayoutSection />
          <Separator />
          <TypographySection />
          <Separator />
          <ThemeSection />
          <Separator />
          <PageSection />
          <Separator />
          {/* <SharingSection /> */}
          <SecTranslation />
          <Separator />
          <SecOptimization />
          {/* <StatisticsSection /> */}
          <Separator />
          {/* <SecImport />
          <Separator /> */}
          <ExportSection />
          <Separator />
          <NotesSection />
          <Separator />
          {/* <InformationSection /> */}
          <Separator />
          {/* <Copyright className="text-center" /> */}
        </div>
      </ScrollArea>

      <ContainerAIChat
        isOpen={isAIChatOpen}
        onClose={() => {
          setIsAIChatOpen(false);
        }}
      />

      <div className="hidden basis-12 flex-col items-center justify-between bg-secondary-accent/30 py-4 sm:flex">
        <div className="flex flex-1 flex-col items-center justify-center gap-y-2">
          <SectionIcon
            id="sec-ai-chat"
            name={t`SecAIChat`}
            onClick={() => {
              // scrollIntoView("#sec-ai-chat");
              setIsAIChatOpen(!isAIChatOpen);
            }}
          />
          <SectionIcon
            id="template"
            name={t`Template`}
            onClick={() => {
              scrollIntoView("#template");
            }}
          />
          <SectionIcon
            id="layout"
            name={t`Layout`}
            onClick={() => {
              scrollIntoView("#layout");
            }}
          />
          <SectionIcon
            id="typography"
            name={t`Typography`}
            onClick={() => {
              scrollIntoView("#typography");
            }}
          />
          <SectionIcon
            id="theme"
            name={t`Theme`}
            onClick={() => {
              scrollIntoView("#theme");
            }}
          />
          <SectionIcon
            id="page"
            name={t`Page`}
            onClick={() => {
              scrollIntoView("#page");
            }}
          />
          {/* <SectionIcon
            id="sharing"
            name={t`Sharing`}
            onClick={() => {
              scrollIntoView("#sharing");
            }}
          /> */}
          {/* <SectionIcon
            id="statistics"
            name={t`Statistics`}
            onClick={() => {
              scrollIntoView("#statistics");
            }}
          /> */}
          <SectionIcon
            className="size-12 rounded-full text-purple-500 hover:text-purple-500"
            id="sec-translation"
            name={t`SecTranslation`}
            onClick={() => {
              scrollIntoView("#sec-translation");
            }}
          />
          <SectionIcon
            className="size-12 rounded-full text-purple-500 hover:text-purple-500"
            id="sec-optimization"
            name={t`SecOptimization`}
            onClick={() => {
              scrollIntoView("#sec-optimization");
            }}
          />
          {/* <SectionIcon
            id="sec-import"
            name={t`SecImport`}
            onClick={() => {
              scrollIntoView("#sec-import");
            }}
          /> */}
          <SectionIcon
            id="export"
            name={t`Export`}
            onClick={() => {
              scrollIntoView("#export");
            }}
          />
          <SectionIcon
            id="notes"
            name={t`Notes`}
            onClick={() => {
              scrollIntoView("#notes");
            }}
          />
          {/* <SectionIcon
            id="information"
            name={t`Information`}
            onClick={() => {
              scrollIntoView("#information");
            }}
          /> */}
        </div>

        {/* <ThemeSwitch size={14} /> */}
      </div>
    </div>
  );
};
